import { Table } from '@components/Table'
import { OverviewTableTemplateProps } from './interface'

export function OverviewTableTemplate({
  title,
  data,
  columns,
}: OverviewTableTemplateProps) {
  return (
    <div className='mt-[40px]'>
      <div className=' text-[14px] font-bold text-secondary-1 mb-[20px]'>
        รายละเอียด :{' '}
        <span className='text-secondary dark:text-dark-10'>{title}</span>
      </div>
      <Table
        data={data}
        columns={columns}
        className='text-secondary dark:text-dark-10 text-[14px] font-light desktop-tablet:mb-[30px] max-h-[450px]'
        getRowProps={row => ({
          className: 'border-b border-gray-3 dark:border-purple h-full',
        })}
        getCellProps={() => ({
          className: 'py-[10px] desktop-tablet:px-[20px] mobile:py-[10px]',
        })}
        fixedHeader
      />
    </div>
  )
}
